export enum SpotRunFlags {
  None = 0,
  Archived = 1 << 0
}
export const SpotRunFlagsMapping: Record<SpotRunFlags, string> = {
  [SpotRunFlags.None]: 'None',
  [SpotRunFlags.Archived]: 'Archived'
};
